const cardKey = "card1"; 
const userKey ="users1"
const cardKeyChoice = "cardChoice1"; 

 function getChoiceCard() {
    const tempCard = localStorage.getItem(cardKeyChoice);
    let card = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : null;
    return card;
}
 function saveChoiceCard(data) {
    localStorage.setItem(cardKeyChoice, JSON.stringify(data));
}

 function getCard() {
    const tempCard = localStorage.getItem(cardKey);
    let card = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    return card;
}

 function saveCard(data) {
    localStorage.setItem(cardKey, JSON.stringify(data));
}

 function addSaveCard(card) {
    let tempCard = localStorage.getItem(cardKey);
    //console.log('1', tempCard);
    //console.log('2', tempCard != null && tempCard != "" ? "**" : "*");
    let oldCard = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    console.log('oldCard', oldCard);
    let newCard = oldCard == null ? [...card] : [...oldCard, ...card];
    console.log('newCard', newCard);
    saveCard(newCard);
    //console.log(localStorage.getItem('card'));
}

 function deleteCard(id) {
    let tempCard = localStorage.getItem(cardKey);

    let oldCard = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    if (oldCard == [])
        return;

    console.log('oldCard', oldCard);
    let article = oldCard.find(m => m.id === id);
    oldCard.splice(oldCard.indexOf(article), 1);

    console.log('article', article);
    console.log('oldCard', oldCard);
    saveCard(oldCard);
    return article;
}

 function emptyCard() {
    localStorage.removeItem(cardKey);
}
 

///----

 function getUsers() {
    const temp = localStorage.getItem(userKey);
    const temp2 = temp != null && temp != "" ? JSON.parse(temp) : [];
    return temp2;
}
 function saveUsers(data) {
    localStorage.setItem(userKey, JSON.stringify(data));
}


 function addUser(user) {
    const temp = localStorage.getItem(userKey); 
    const old = temp != null && temp != "" ? JSON.parse(temp) : []; 
    const new2 = old == null ? [...user] : [...old, ...user]; 
    saveUsers(new2);
    //console.log(localStorage.getItem('card'));
}

 function deleteUser(id) {
    const tempCard = localStorage.getItem(userKey);
    const old = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    if (old == [])
        return; 
    const article = old.find(m => m.id === id);
    old.splice(old.indexOf(article), 1); 
    saveUsers(old);
    return article;
}

 function emptyUser() {
    localStorage.removeItem(userKey);
}
///--
export  default { 
    getChoiceCard,saveChoiceCard,getCard,saveCard,
    addSaveCard,    deleteCard,   emptyCard,
    emptyUser,deleteUser,addUser,saveUsers,getUsers
};